var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-title"},[_c('p',[_vm._v(_vm._s(_vm.desc))]),(_vm.desc2)?_c('p',{staticStyle:{"padding-top":"4px"}},[_vm._v(_vm._s(_vm.desc2))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }